/** Marque Scola : toque bleue, utilisée quand l'école n'a pas encore de logo. */
export function PlatformMark(props: { class?: string; testId?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      class={props.class ?? "h-10 w-10 shrink-0"}
      data-testid={props.testId}
      role="img"
      aria-label="Scola"
    >
      <rect width="32" height="32" rx="8" fill="#2858E8" />
      <polygon points="16,8.2 24.6,12.2 16,16.2 7.4,12.2" fill="#ffffff" />
      <path
        d="M11.15 14.15c.4 2.35 2.15 3.55 4.85 3.55s4.45-1.2 4.85-3.55"
        fill="none"
        stroke="#ffffff"
        stroke-width="1.45"
        stroke-linecap="round"
      />
      <circle cx="16" cy="12.2" r="0.9" fill="#F0A83A" />
      <path
        d="M16.7 12.45 L19.7 14.7 L19.7 17.35"
        fill="none"
        stroke="#F0A83A"
        stroke-width="1.05"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <ellipse cx="19.7" cy="18.5" rx="1.1" ry="1.4" fill="#F0A83A" />
    </svg>
  );
}
